import { StyleSheet, View } from "react-native";
import BlankLayout from "../layouts/BlankLayout";
import CustomText from "../components/common/general/CustomText/CustomText";
import CustomSpacing from "../components/common/layout/CustomSpacing/CustomSpacing";
import { colors, spacing } from "../styles/design-system";

function CourseModernizerAccessDeniedView() {
  return (
    <BlankLayout>
      <View style={styles.fullScreenCenter}>
        <View style={styles.messageContainer}>
          <CustomText
            role="header"
            text="Student accounts do not have Course Modernizer access."
            size="l"
            textType="display"
            weight="bold"
            useTranslationText={false}
            style={styles.textCenter}
          />
          <CustomSpacing size="s" />
          <CustomText
            role="header"
            text="Please try again with a faculty account."
            size="m"
            weight="regular"
            useTranslationText={false}
            style={styles.textCenter}
          />
        </View>
      </View>
    </BlankLayout>
  );
}

const styles = StyleSheet.create({
  fullScreenCenter: {
    width: "100%",
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: colors.grey[50],
  },
  messageContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    padding: spacing.lg,
    maxWidth: 520,
    alignSelf: "center",
  },
  textCenter: {
    textAlign: "center",
  },
});

export default CourseModernizerAccessDeniedView;
